import { getEnvironment } from '../../../common/utils/environment';

export const getAdminhubLink: ({ orgId }: { orgId: string }) => string = ({
	orgId,
}: {
	orgId: string;
}): string => {
	const env = getEnvironment();
	const route = `o/${orgId}/rovo`;

	switch (env) {
		case 'development':
		case 'staging':
			return `https://admin.stg.atlassian.com/${route}`;
		default:
			return `https://admin.atlassian.com/${route}`;
	}
};
